export default __webpack_public_path__ + "static/media/Pamungkas - Kenangan Manis (Lyrics Video).c1ae4833.mp3";